import { createAction } from "@coverme/redux";

export const setSectionComplete = section => {
    return createAction("SET_SECTION_COMPLETE", section);
};
